export default __webpack_public_path__ + "static/media/Red0000.dbfdc309.png";